<ndt-edit-presence-contact-view
   [callState]="callState | async"
   [form]="form"
   [presenceContactPrivileges]="presenceContactPrivileges$ | async"
   [extensionPhonePrivileges]="extensionPhonePrivileges$ | async"
   [presenceContactExtensionId]="presenceContactExtensionId"
   [selectedAccountId]="selectedAccountId$ | async"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
>
</ndt-edit-presence-contact-view>
